<template>
    <div class="page">
        <transition name="fade-transition">
            <v-container v-if="teachers && !loading" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
                <v-row v-if="pcOnly">
                    <v-col v-for="teacher in teachers" :key="teacher.id" md="3" lg="3" xl="2">
                        <teacher-card :teacher="teacher" />
                    </v-col>
                </v-row>
                <v-list v-else class="py-0">
                    <teacher-list-item
                        v-for="(teacher, i) in teachers"
                        :key="teacher.id"
                        :teacher="teacher"
                        :divider="i < teachers.length - 1"
                    />
                </v-list>
            </v-container>
        </transition>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import TeacherCard from '@/components/custom/teacher-card'
import TeacherListItem from '@/components/custom/teacher-list-item'

export default {
    name: 'Teachers',
    components: {
        TeacherCard,
        TeacherListItem,
    },
    data() {
        return {
            teachers: null,
            loading: false,
            openingExam: false,
        };
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        loading(loading) {
            this.setLinearLoading(loading);
        },
        openingExam(loading) {
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        getTeachers() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            const url = '/teachers';
            this.$store.dispatch('fastGetAction', { url }).then(response => {
                this.loading = false;
                this.teachers = response.data.data;
            }).catch(() => {
                this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                this.loading = false;
            });
        },
    },
    mounted() {
        if (this.appData.teachers_page) {
            this.getTeachers();
        } else {
            this.$router.push('/not-found');
        }
    },
};
</script>
